(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nov-product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
            Currency.convertAll(shopCurrency, $('#currencies span.selected').attr('data-currency'));
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tab-accordion"] && !window.DesignMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const tabButtons = document.querySelectorAll(".faq-tabs-nav button");
  const tabContents = document.querySelectorAll(".faq-tab-content");

  tabButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      const selectedTab = btn.getAttribute("data-tab");

      // 激活按钮
      tabButtons.forEach(b => b.classList.remove("active"));
      btn.classList.add("active");

      // 激活对应 tab 内容
      tabContents.forEach(content => {
        if (content.getAttribute("data-tab") === selectedTab) {
          content.classList.add("active");
        } else {
          content.classList.remove("active");
        }
      });
    });
  });

  // 手风琴功能（点击同一个问题时可关闭）
  document.querySelectorAll('.faq-tab-content').forEach(tabContent => {
    tabContent.addEventListener('click', function (e) {
      const clickedQuestion = e.target.closest('.faq-question');
      if (clickedQuestion) {
        const answer = clickedQuestion.nextElementSibling;

        const isActive = clickedQuestion.classList.contains('active');

        // 先关闭所有
        const allQuestions = tabContent.querySelectorAll('.faq-question');
        const allAnswers = tabContent.querySelectorAll('.faq-answer');
        allQuestions.forEach(q => q.classList.remove('active'));
        allAnswers.forEach(a => a.classList.remove('open'));

        // 如果当前项不是打开状态，就打开它
        if (!isActive) {
          clickedQuestion.classList.add('active');
          if (answer && answer.classList.contains('faq-answer')) {
            answer.classList.add('open');
          }
        }
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
